import { styled } from '@mui/material/styles';
import MuiAccordion from '@mui/material/Accordion';
import { AccordionDetails, AccordionSummary } from '@mui/material';

const textStyles = {
  fontSize: '14px',
  lineHeight: '24px',
  fontWeight: 'bold',
  color: '#606060',
};

export const StyledAccordion = styled(MuiAccordion)(({ theme }) => ({
  borderRadius: '12px!important',
  margin: '0!important',
  boxShadow: 'none',
  border: '1px solid #DFDFDF',
  backgroundColor: '#F5F6FA',
  padding: '0px 24px 0',
  [theme.breakpoints.down(1520)]: {
    padding: '0px 16px 0',
    borderRadius: '10px!important',
  },
  '&:before': {
    display: 'none',
  },
}));

export const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  padding: '12px 0',
  ...textStyles,
  backgroundColor: 'transparent',
  borderRadius: '0!important',
  borderBottom: 'none!important',
  [theme.breakpoints.down(1520)]: {
    padding: '8px 0',
    minHeight: '40px',
  },

  '&.Mui-expanded': {
    margin: 0,
    minHeight: 0,
    borderRadius: '8px 8px 0 0!important',
    borderBottom: '1px solid #DFDFDF!important',
  },

  '& .MuiAccordionSummary-content': {
    margin: 0,
    padding: 0,
    border: 'none',
    ...textStyles,

    '&.Mui-expanded': {
      margin: 0,
      minHeight: 0,
    },
  },

  '& .MuiAccordionSummary-expandIconWrapper': {
    transform: 'rotate(270deg)',
    transition: 'transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',

    '&.Mui-expanded': {
      transform: 'rotate(360deg)',
    },

    '& .MuiSvgIcon-root': {
      color: '#606060',
    },
  },
}));

export const StyledAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  padding: '24px 0 0',
  [theme.breakpoints.down(1520)]: {
    paddingTop: '16px',
  },
}));
